import history from './store/history'
import { ConnectedRouter } from 'connected-react-router'
import { loadModules } from "./store/loadModule";
import Main from "./pages/main/main";
import React from "react";
import { PermissionsModule } from "./modules/permission";
import SnackbarProviderExtended from "./components/messages/snackbarProviderExtended/snackbarProviderExtended";
import './fonts.css'
import './App.css'
import ThemeCustomization from "./themes";

export const ENABLED_MODULES = loadModules([PermissionsModule])

export const ROUTES = ENABLED_MODULES.loadRoutes()

function App() {
	return (
		<ThemeCustomization>
			<SnackbarProviderExtended>
				<ConnectedRouter history={history}>
					<Main/>
				</ConnectedRouter>
			</SnackbarProviderExtended>
		</ThemeCustomization>
	)
}

export default App
